import React, { useContext, useEffect, useRef, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { GlobalContext } from "../../Context/GlobalState";
import swal from "sweetalert";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
import { billpunchbasicauth } from "../../utils/Credentials";

const Filesharing = () => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewItem, setPreviewItem] = useState(null);
  const fileInputRef = useRef(null);
  const [sharedFiles, setSharedFiles] = useState([]);
  const [sharedFilesLoading, setSharedFilesLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadedfeatureImageUrl, setUploadedfeatureImageUrl] = useState(null);
  const [employeeList, setEmployeeList] = useState([]);
  const [employeeLoading, setEmployeeLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);

  const [shareType, setShareType] = useState("text");
  const [formData, setFormData] = useState({
    title: "",
    message: "",
    code: "",
    sendTo: "",
  });
  const getShareTypeValue = (type) => {
    switch (type) {
      case "text":
        return 1;
      case "description":
        return 2;
      case "code":
        return 3;
      case "file":
        return 0;
      default:
        return 0;
    }
  };
  const getTypeLabel = (type) => {
    switch (Number(type)) {
      case 0:
        return "File";
      case 1:
        return "Text";
      case 2:
        return "Description";
      case 3:
        return "Code";
      default:
        return "-";
    }
  };
  const handlePreview = (item) => {
    setPreviewItem(item);
    setShowPreviewModal(true);
  };
  const handleCreateShare = async () => {
    if (!formData.title || !formData.sendTo) {
      return;
    }

    let fileUrl = "";

    try {
      setTransactionLoaderState(true);

      if (shareType === "file") {
        if (!selectedFile) {
          return;
        }

        const formDataUpload = new FormData();
        formDataUpload.append("file", selectedFile);

        const uploadResponse = await fetch(
          "https://billpunch.com/api/uploadfile.php",
          {
            method: "POST",
            body: formDataUpload,
          },
        );

        const uploadResult = await uploadResponse.json();

        if (uploadResult.status !== "success") {
          return;
        }

        fileUrl = uploadResult.file_url || "";
      }

      const payload = {
        type: getShareTypeValue(shareType),
        title: formData.title,
        desc: shareType === "code" ? formData.code : formData.message,
        file: fileUrl,
        reciever: String(formData.sendTo),
        sender: String(user?.userid),
        firmid: String(user?.firm_id || user?.firmId),
      };

      const saveResponse = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/Filesharing`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const saveResult = await saveResponse.json();

      if (saveResult.status === "0") {
        setShowModal(false);
        setSelectedFile(null);
        setFormData({
          title: "",
          message: "",
          code: "",
          sendTo: "",
        });
        setShareType("text");
        fetchSharedFiles();
      }
    } catch (error) {
      console.error("Create share error:", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };
  const [uploadDetails, setUploadDetails] = useState({
    title: "",
    sendTo: "",
    description: "",
  });

  const { password, username } = billpunchbasicauth;
  const base64Credentials = btoa(`${username}:${password}`);

  useEffect(() => {
    fetchEmployees();
    fetchSharedFiles();
  }, []);

  const fetchSharedFiles = async () => {
    setSharedFilesLoading(true);

    try {
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/Getsharedfile`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            empId: Number(user?.userid),
            firmId: Number(user?.firm_id || user?.firmId),
          }),
        },
      );

      const data = await res.json();

      if (data?.status === "0") {
        setSharedFiles(data?.data || []);
      } else {
        setSharedFiles([]);
        console.error("API Error:", data?.msg);
      }
    } catch (error) {
      setSharedFiles([]);
      console.error("Fetch Error:", error.message);
    } finally {
      setSharedFilesLoading(false);
    }
  };

  const fetchEmployees = async () => {
    setEmployeeLoading(true);
    try {
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/getEmployee`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ firmId: user.firm_id }),
        },
      );

      const data = await res.json();

      if (res.ok) {
        setEmployeeList(Array.isArray(data) ? data : data?.data || []);
      } else {
        setEmployeeList([]);
        swal({
          title: "Error!",
          text: data?.message || "Failed to load employee list.",
          icon: "error",
          button: "OK",
        });
      }
    } catch (error) {
      setEmployeeList([]);
      swal({
        title: "Error!",
        text: error.message || "Failed to load employee list.",
        icon: "error",
        button: "OK",
      });
    } finally {
      setEmployeeLoading(false);
    }
  };

  const getEmployeeName = (emp) => {
    return [emp.firstname, emp.middlename, emp.lastname]
      .filter(Boolean)
      .join(" ");
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file || null);
  };

  const openFilePicker = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handlefeatureImageUpload = async () => {
    if (!selectedFile) {
      swal({
        title: "Error!",
        text: "Please select a file first.",
        icon: "error",
        button: "OK",
      });
      return;
    }

    if (
      !uploadDetails.title ||
      !uploadDetails.sendTo ||
      !uploadDetails.description
    ) {
      swal({
        title: "Error!",
        text: "Please fill all upload details.",
        icon: "error",
        button: "OK",
      });
      return;
    }

    setTransactionLoaderState(true);

    try {
      const formDataUpload = new FormData();
      formDataUpload.append("file", selectedFile);

      const uploadResponse = await fetch(
        "https://billpunch.com/api/uploadfile.php",
        {
          method: "POST",
          body: formDataUpload,
        },
      );

      const uploadResult = await uploadResponse.json();

      if (uploadResult.status !== "success") {
        swal({
          title: "Error!",
          text: uploadResult.message || "File upload failed.",
          icon: "error",
          button: "OK",
        });
        return;
      }

      const uploadedFileUrl = uploadResult.file_url;
      setUploadedfeatureImageUrl(uploadedFileUrl);

      const sharePayload = {
        type: 0,
        title: uploadDetails.title,
        desc: uploadDetails.description,
        file: uploadedFileUrl,
        reciever: uploadDetails.sendTo,
        sender: String(user?.userid || ""),
        firmid: String(user?.firm_id || ""),
      };

      const saveResponse = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/Filesharing`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sharePayload),
        },
      );

      const saveResult = await saveResponse.json();

      if (saveResult.status === "0") {
        swal({
          title: "Success!",
          text:
            saveResult.result || saveResult.msg || "File shared successfully.",
          icon: "success",
          button: "OK",
        });

        setShowUploadModal(false);
        setSelectedFile(null);
        setUploadDetails({
          title: "",
          sendTo: "",
          description: "",
        });
      } else {
        swal({
          title: "Error!",
          text: saveResult.result || saveResult.msg || "File sharing failed.",
          icon: "error",
          button: "OK",
        });
      }
    } catch (error) {
      swal({
        title: "Error!",
        text: `Upload failed: ${error.message}`,
        icon: "error",
        button: "OK",
      });
    } finally {
      setTransactionLoaderState(false);
    }
  };
  const getEmployeeNameById = (id) => {
    const emp = employeeList.find((item) => String(item.empid) === String(id));

    if (!emp) return id;

    return [emp.firstname, emp.middlename, emp.lastname]
      .filter(Boolean)
      .join(" ");
  };

  const getFileNameFromUrl = (url) => {
    if (!url) return "-";
    try {
      return decodeURIComponent(url.split("/").pop());
    } catch {
      return url.split("/").pop();
    }
  };

  const getFileExtension = (url) => {
    const fileName = getFileNameFromUrl(url);
    return fileName.includes(".")
      ? fileName.split(".").pop().toUpperCase()
      : "-";
  };
  const filteredFiles = sharedFiles.filter((file) => {
    const fileName = getFileNameFromUrl(file.file || "");
    const senderName = String(getEmployeeNameById(file.sender)).toLowerCase();
    const title = String(file.title || "").toLowerCase();
    const desc = String(file.desc || "").toLowerCase();
    const query = searchTerm.toLowerCase();

    return (
      fileName.toLowerCase().includes(query) ||
      title.includes(query) ||
      desc.includes(query) ||
      senderName.includes(query) ||
      getTypeLabel(file.type).toLowerCase().includes(query)
    );
  });
  return (
    <>
      <div className="mt-3">
        <div
          className="p-3"
          style={{
            background: "#f8f9fa",
            borderRadius: "16px",
            boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
          }}
        >
          <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
            <div>
              <h3 style={{ margin: 0, fontWeight: "700", color: "#212529" }}>
                File Sharing
              </h3>
              <p style={{ margin: "6px 0 0", color: "#6c757d" }}>
                Share and receive files easily
              </p>
            </div>

            <button
              className="btn btn-primary"
              onClick={() => setShowModal(true)}
            >
              + New Share
            </button>
          </div>

          <div className="row g-3">
            <div className="col-md-3">
              <div
                style={{
                  background: "#fff",
                  borderRadius: "14px",
                  padding: "20px",
                  border: "1px solid #e9ecef",
                  height: "100%",
                }}
              >
                <h5 style={{ fontWeight: "600", marginBottom: "18px" }}>
                  Upload File
                </h5>

                <div
                  onClick={openFilePicker}
                  style={{
                    border: "2px dashed #ced4da",
                    borderRadius: "12px",
                    padding: "30px 20px",
                    textAlign: "center",
                    background: "#fdfdfd",
                    cursor: "pointer",
                  }}
                >
                  <div style={{ fontSize: "40px", marginBottom: "10px" }}>
                    📁
                  </div>
                  <p style={{ marginBottom: "10px", color: "#6c757d" }}>
                    Drag & drop file here
                  </p>

                  <label
                    htmlFor="fileUpload"
                    onClick={(e) => e.stopPropagation()}
                    style={{
                      display: "inline-block",
                      background: "#198754",
                      color: "#fff",
                      padding: "10px 18px",
                      borderRadius: "8px",
                      cursor: "pointer",
                      fontWeight: "500",
                    }}
                  >
                    Browse File
                  </label>

                  <input
                    ref={fileInputRef}
                    id="fileUpload"
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />

                  {selectedFile && (
                    <div
                      style={{
                        marginTop: "15px",
                        padding: "10px",
                        background: "#eef6ff",
                        borderRadius: "8px",
                        fontSize: "14px",
                        color: "#0d6efd",
                        fontWeight: "500",
                      }}
                    >
                      Selected: {selectedFile.name}
                    </div>
                  )}
                </div>

                <button
                  className="btn w-100 mt-3"
                  onClick={() => {
                    if (!selectedFile) {
                      swal({
                        title: "Error!",
                        text: "Please select a file first.",
                        icon: "error",
                        button: "OK",
                      });
                      return;
                    }
                    setShowUploadModal(true);
                  }}
                  style={{
                    background: "#0d6efd",
                    color: "#fff",
                    borderRadius: "10px",
                    padding: "10px",
                    fontWeight: "600",
                    border: "none",
                  }}
                >
                  Upload Now
                </button>
              </div>
            </div>

            <div className="col-md-9">
              <div
                style={{
                  background: "#fff",
                  borderRadius: "14px",
                  padding: "20px",
                  border: "1px solid #e9ecef",
                }}
              >
                <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
                  <h5 style={{ fontWeight: "600", margin: 0 }}>
                    Shared / Received Files
                  </h5>

                  <input
                    type="text"
                    placeholder="Search files..."
                    className="form-control"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                      maxWidth: "250px",
                      borderRadius: "10px",
                      boxShadow: "none",
                    }}
                  />
                </div>

                <div className="table-responsive">
                  <table className="table align-middle">
                    <thead>
                      <tr>
                        <th>Title</th>
                        <th>File Name</th>
                        <th>Type</th>
                        <th>Sender</th>
                        <th>Description</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sharedFilesLoading ? (
                        <tr>
                          <td colSpan="6" className="text-center py-4">
                            Loading files...
                          </td>
                        </tr>
                      ) : filteredFiles.length > 0 ? (
                        filteredFiles.map((file) => (
                          <tr key={file.id}>
                            <td
                              style={{ fontWeight: "500", fontSize: ".9rem" }}
                            >
                              {file.title || "-"}
                            </td>
                            <td style={{ fontSize: ".9rem" }}>
                              {Number(file.type) === 0
                                ? getFileNameFromUrl(file.file)
                                : "-"}
                            </td>
                            <td style={{ fontSize: ".9rem" }}>
                              {getTypeLabel(file.type)}
                            </td>
                            <td style={{ fontSize: ".9rem" }}>
                              {getEmployeeNameById(file.sender)}
                            </td>
                            <td style={{ fontSize: ".9rem" }}>
                              {file.desc
                                ? file.desc.length > 50
                                  ? `${file.desc.slice(0, 50)}...`
                                  : file.desc
                                : "-"}
                            </td>
                            <td style={{ fontSize: ".9rem" }}>
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-secondary me-2"
                                onClick={() => handlePreview(file)}
                              >
                                View
                              </button>

                              {Number(file.type) === 0 && file.file ? (
                                <a
                                  href={file.file}
                                  download
                                  className="btn btn-sm btn-primary"
                                >
                                  Download
                                </a>
                              ) : (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-primary"
                                  disabled
                                >
                                  Download
                                </button>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center py-4">
                            No shared files found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* {uploadedfeatureImageUrl && (
                  <div className="alert alert-success mt-3 mb-0">
                    Uploaded URL:{" "}
                    <a
                      href={uploadedfeatureImageUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {uploadedfeatureImageUrl}
                    </a>
                  </div>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Create New Share</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form>
            <div className="mb-3">
              <label className="form-label fw-semibold">Share Type</label>
              <select
                className="form-select"
                value={shareType}
                onChange={(e) => setShareType(e.target.value)}
              >
                <option value="text">Direct Text</option>
                <option value="description">Long Description</option>
                <option value="code">Code</option>
                <option value="file">File Upload</option>
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Send To</label>
              <select
                className="form-select"
                value={formData.sendTo}
                onChange={(e) =>
                  setFormData({ ...formData, sendTo: e.target.value })
                }
              >
                <option value="">
                  {employeeLoading ? "Loading employees..." : "Select employee"}
                </option>
                {employeeList.map((emp, index) => (
                  <option key={emp.empid || index} value={emp.empid}>
                    {[emp.firstname, emp.middlename, emp.lastname]
                      .filter(Boolean)
                      .join(" ")}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Title</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter title"
                value={formData.title}
                onChange={(e) =>
                  setFormData({ ...formData, title: e.target.value })
                }
              />
            </div>

            {(shareType === "text" || shareType === "description") && (
              <div className="mb-3">
                <label className="form-label fw-semibold">
                  {shareType === "text" ? "Message" : "Description"}
                </label>
                <textarea
                  className="form-control"
                  rows={shareType === "text" ? 4 : 8}
                  placeholder="Write here..."
                  value={formData.message}
                  onChange={(e) =>
                    setFormData({ ...formData, message: e.target.value })
                  }
                />
              </div>
            )}

            {shareType === "code" && (
              <div className="mb-3">
                <label className="form-label fw-semibold">Code</label>
                <textarea
                  className="form-control bg-dark text-light"
                  rows={10}
                  placeholder="Paste code here..."
                  value={formData.code}
                  onChange={(e) =>
                    setFormData({ ...formData, code: e.target.value })
                  }
                />
              </div>
            )}

            {shareType === "file" && (
              <div className="mb-3">
                <label className="form-label fw-semibold">Upload File</label>
                <input
                  type="file"
                  className="form-control"
                  onChange={handleFileChange}
                />
                {selectedFile && (
                  <small className="text-primary d-block mt-2">
                    Selected: {selectedFile.name}
                  </small>
                )}
              </div>
            )}
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleCreateShare}>
            Share Now
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showUploadModal}
        onHide={() => setShowUploadModal(false)}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Upload File Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-3">
            <label className="form-label fw-semibold">File Title</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter file title"
              value={uploadDetails.title}
              onChange={(e) =>
                setUploadDetails({ ...uploadDetails, title: e.target.value })
              }
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">Send To</label>
            <select
              className="form-select"
              value={uploadDetails.sendTo}
              onChange={(e) =>
                setUploadDetails({ ...uploadDetails, sendTo: e.target.value })
              }
            >
              <option value="">
                {employeeLoading ? "Loading employees..." : "Select employee"}
              </option>
              {employeeList.map((emp, index) => (
                <option key={emp.empid || index} value={emp.empid}>
                  {getEmployeeName(emp)}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">Description</label>
            <textarea
              className="form-control"
              rows={4}
              placeholder="Enter description"
              value={uploadDetails.description}
              onChange={(e) =>
                setUploadDetails({
                  ...uploadDetails,
                  description: e.target.value,
                })
              }
            />
          </div>

          {selectedFile && (
            <div className="alert alert-light border mb-0">
              <strong>Selected File:</strong> {selectedFile.name}
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowUploadModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handlefeatureImageUpload}>
            Submit & Upload
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showPreviewModal}
        onHide={() => {
          setShowPreviewModal(false);
          setPreviewItem(null);
        }}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{previewItem?.title || "Preview"}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {previewItem && (
            <>
              <div className="mb-3">
                <strong>Type:</strong> {getTypeLabel(previewItem.type)}
              </div>

              <div className="mb-3">
                <strong>Sender:</strong>{" "}
                {getEmployeeNameById(previewItem.sender)}
              </div>

              {Number(previewItem.type) === 0 ? (
                <div>
                  <p className="mb-2">
                    <strong>File Name:</strong>{" "}
                    {getFileNameFromUrl(previewItem.file)}
                  </p>

                  {previewItem.file && (
                    <a
                      href={previewItem.file}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-primary"
                    >
                      Open File
                    </a>
                  )}
                </div>
              ) : Number(previewItem.type) === 3 ? (
                <div>
                  <label className="form-label fw-semibold">Code</label>
                  <textarea
                    className="form-control bg-dark text-light"
                    rows={16}
                    value={previewItem.desc || ""}
                    readOnly
                  />
                </div>
              ) : (
                <div>
                  <label className="form-label fw-semibold">
                    {Number(previewItem.type) === 1 ? "Text" : "Description"}
                  </label>
                  <textarea
                    className="form-control"
                    rows={12}
                    value={previewItem.desc || ""}
                    readOnly
                  />
                </div>
              )}
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowPreviewModal(false);
              setPreviewItem(null);
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Filesharing;
